import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchSpot, updateSpot, deleteSpot } from '../../store/slices/savedSpotsSlice';
import Header from '../../layout/Header'
import MobileNav from '../../layout/MobileNav'
import PageNavSavedLocation from '../../layout/PageNavSavedLocation';
import Input from '../../components/fields/Input';
import ButtonLightBlue from '../../components/buttons/ButtonLightBlue';
import Dialog from '../../components/common/Dialog';
import {SuccessMessage, ErrorMessage} from '../../components/messages/success';
import ButtonRedInverted from '../../components/buttons/ButtonRedInverted';
import ButtonLinkLightBlue from '../../components/buttons/ButtonLinkLightBlue'
import {Helmet} from "react-helmet";

const SpotAlerts = () => {

    const { id } = useParams();
    const { spots, errors, isDeleting, isUpdating } = useSelector(state => state.savedSpots);
    const currentSpot = id ? spots[id] : null;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [deleteMessage, setDeleteMessage] = React.useState(null);
    const [showDialog, setShowDialog] = React.useState(false);
    
    const [formData, setFormData] = useState({
        name: currentSpot?.name || ''
    });

    React.useEffect(() => {
        dispatch(fetchSpot(id));
    }, [dispatch, id]);

    React.useEffect(() => {
        if (currentSpot) {
            setFormData({
                name: currentSpot.name || ''
            });
        }
    }, [currentSpot]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDelete = async () => {
        try {
            const spotName = currentSpot.name;
            await dispatch(deleteSpot(currentSpot.id)).unwrap();
            setDeleteMessage(`${spotName} has been archived`);
            setShowDialog(false);
            console.log('Archive successful, message set:', `${spotName} has been archived`);
        } catch (error) {
            console.error('Archive failed:', error);
            setDeleteMessage('Failed to archive spot');
            setShowDialog(false);
        }
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        
        const spotData = {
            name: formData.name
        };

        try {

            const result = await dispatch(updateSpot({spotId: id, spotData})).unwrap();

            console.log('Spot updated successfully:', result);
            navigate('/location/' + id + '/view');

        } catch (error) {
            console.error('Failed to update spot:', error);
        }
    };

    if(!currentSpot && !deleteMessage){
       return <p>Fetching Data...</p>
    }

    return (
        <>
            <Helmet>
                <title>SpotAlerts | Oreca Pro</title>
                <link rel="canonical" href={window.location.href} />
            </Helmet>
            <Header />
            <MobileNav />

            <Dialog
                isOpen={showDialog}
                onClose={() => setShowDialog(false)}
                onConfirm={handleDelete}
                title="Archive Spot"
                confirmText="Archive Spot"
                cancelText="Cancel"
                isLoading={isDeleting}
            >
                <p className="text-custom-light-grey">Are you sure you want to archive "{currentSpot?.name}"? You will be able to restore it later.</p>
            </Dialog>

            <div className='py-[80px] px-5 max-w-[1100px] mx-auto'>
                {deleteMessage ? (
                    <div className="max-w-[400px] mx-auto mt-10">
                        {deleteMessage.includes('Failed') ? (
                            <ErrorMessage message={deleteMessage} />
                        ) : (
                            <SuccessMessage message={deleteMessage} />
                        )}
                        <div className="mt-6">
                            <ButtonLinkLightBlue 
                                href="/"
                                text="Back to Map"
                            />
                        </div>
                    </div>
                ) : (
                    <>
                        <h1 className='text-2xl font-semibold mb-2 md:mt-8'>{currentSpot.name ? currentSpot.name : "Current Spot"}</h1>
                        <p className='text-xs text-custom-light-grey'>
                            {Number(currentSpot.latitude).toFixed(2)}, {Number(currentSpot.longitude).toFixed(2)}
                        </p>

                        <PageNavSavedLocation id={currentSpot.id} />

                        <p className='mt-10'>
                            This feature is coming soon. Stay tuned for getting notified when your spot turns on.
                        </p>
                    </>
                )}

                
            </div>
            
        </>
    )
};

export default SpotAlerts;
